<mat-card class="applications-card">
  <mat-card-header>
    <mat-card-title class="card-title">{{ title }}</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <table mat-table [dataSource]="newApplications" class="applications-table">
      <!-- Index Column -->
      <ng-container matColumnDef="index">
        <th mat-header-cell *matHeaderCellDef class="index-column">#</th>
        <td mat-cell *matCellDef="let element; let i = index" class="index-column">
          {{ i + 1 }}
        </td>
      </ng-container>

      <!-- Company Name Column -->
      <ng-container matColumnDef="companyName">
        <th mat-header-cell *matHeaderCellDef>{{ 'dashboard.companyName' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          {{ element.companyName }}
        </td>
      </ng-container>

      <!-- Created At Column -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef class="date-column">{{ 'dashboard.date' | translate }}</th>
        <td mat-cell *matCellDef="let element" class="date-column">
          {{ formatDate(element.createdAt) }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="table-row"
        (click)="onRowClick(row)">
      </tr>
    </table>
  </mat-card-content>
</mat-card>
